import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {ActiveMatchmakingMatchTypes} from '../../../shared/matchmaking/MatchmakingEnums'
import {UIUrlParameterNames} from '../../shared/scripts/ui_html/UIUrlController'
import {UIEntryUrlParameterController} from '../../shared/scripts/UIEntryUrlParameterController'
import {uiManager} from './EntryMobile'
import {clientIntl} from '../../shared/scripts/ClientI18n'
import {GameTypeEnum} from './ui_html/main_page/body/homepage/matchmaking_selection/UIMMatchmakingController'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend'

export class EntryUrlParameterController extends UIEntryUrlParameterController {
    static async loadParameterEvents() {
        const urlParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))
        for(const parameterName of urlParams.keys()) {
            const parameterValue = urlParams.get(parameterName)
            if(parameterValue == null) continue
            switch(parameterName as UIUrlParameterNames) {
                case UIUrlParameterNames.EnterMatchmaking: this.loadMatchmakingQueue(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.Campaign: this.loadCampaignMode(parameterValue); this.removeParameter(); break
                default: break
            }
        }
    }

    static removeParameter() {
        window.history.replaceState({}, document.title, clientIntl.getLanguagePathPrefix() || '/')
    }

    static loadCampaignMode(parameter: string) {
        if(parameter != this.DEFAULT_PARAMETER_VALUE) return

        void SocketLobbySend.continueCampaignMode()
    }

    static loadMatchmakingQueue(parameter: string) {
        const mmController = uiManager.mainpageController.bodyController.homepageController.matchmakingController
        switch(Number(parameter) as ActiveMatchmakingMatchTypes) {
            case MatchmakingMatchTypes.UnrankedClassic4P:
                void mmController.startSearching(GameTypeEnum.Classic4P, false)
                break
            case MatchmakingMatchTypes.RankedClassic4P:
                void mmController.startSearching(GameTypeEnum.Classic4P, true)
                break
            case MatchmakingMatchTypes.UnrankedClassic1v1:
                void mmController.startSearching(GameTypeEnum.Classic1v1, false)
                break
            case MatchmakingMatchTypes.RankedClassic1v1:
                void mmController.startSearching(GameTypeEnum.Classic1v1, true)
                break
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                void mmController.startSearching(GameTypeEnum.CitiesAndKnights4P, true)
                break
        }
    }
}
